import { useMutation, useQuery } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import Box from "ds/components/Box";
import FormToggleField from "ds/components/Form/ToggleField";
import useTypedContext from "hooks/useTypedContext";

import styles from "./styles.module.css";
import {
  GET_API_KEYS_MANAGEABLE_BY_NON_HUMANS,
  TOGGLE_API_KEYS_MANAGEABLE_BY_NON_HUMANS,
} from "./gql";

const ApiKeyCreationFromNonHumansToggle = () => {
  const { onError } = useTypedContext(FlashContext);
  const { data, loading: isLoading } = useQuery(GET_API_KEYS_MANAGEABLE_BY_NON_HUMANS, {});

  const [mutate, { loading: isSaving }] = useMutation(TOGGLE_API_KEYS_MANAGEABLE_BY_NON_HUMANS, {
    onError,
  });

  const toggle = useCallback(
    () =>
      mutate({
        refetchQueries: [{ query: GET_API_KEYS_MANAGEABLE_BY_NON_HUMANS },],
        awaitRefetchQueries: true,
      }),
    [mutate]
  );

  return (
    <Box className={styles.managementToggle} fullWidth>
      <FormToggleField
        variant="switch"
        title="API key creation from non-human sessions"
        description="Allow API keys to create, update, and delete other API keys."
        checked={data?.apiKeysManageableByNonHumans || false}
        onChange={toggle}
        disabled={isLoading || isSaving}
      />
    </Box>
  );
};

export default ApiKeyCreationFromNonHumansToggle;